import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { StatisticCardShell } from './statistic-card-shell';

const StyledNoDataBody = styled(Stack)(() => ({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledNoDataText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 400,
  lineHeight: 1.4,
  color: theme.palette.text.second,
  textAlign: 'center',
}));

/**
 * Empty state placeholder for a statistic card when no data is available.
 * Preserves the card shell dimensions so the layout does not shift.
 */
export const StatisticCardNoData: FC = () => {
  const { t } = useTranslation('communityStats');

  return (
    <StatisticCardShell>
      <StyledNoDataBody>
        <StyledNoDataText>{t('statisticCards.noDataState')}</StyledNoDataText>
      </StyledNoDataBody>
    </StatisticCardShell>
  );
};
